module.exports = __webpack_public_path__ + "img/jifen.ff0896ac.svg";